import { useSearchQueryParams } from '@/features/shared/hooks/search'

export const useHasSignupPromotionQueryParam = () => {
  const { email, employee_id, gift_code, param, r, referrerUrl, zip } = useSearchQueryParams()

  return Boolean(email || employee_id || gift_code || param || r || referrerUrl || zip)
}
